import { useMediaQuery, useTheme } from "@material-ui/core"
import React from "react"
import Cabecalho from "../Cabecalho"
import { Configuracoes } from "./components/Configuracoes"
import { Notinha } from "./components/Notinha"
import { useImpressaoNova } from "./hooks/useImpressaoNova"

export function TextosImpressao() {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { usarImpressaoNova, carregandoImpressaoNova, alterarImpressaoNova } = useImpressaoNova()

    return (
        <div>
            <Cabecalho pagina="Editar texto impresso" />

            <div
                style={{
                    width: isMobile ? "100vw" : "calc(100vw - 80px)",
                    marginTop: "64px",
                    marginLeft: isMobile ? 0 : "80px",
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    height: isMobile ? "auto" : "calc(100vh - 64px)",
                    overflow: isMobile ? "visible" : "hidden",
                }}
            >
                {!isMobile && usarImpressaoNova && (
                    <div
                        style={{
                            width: "60%",
                            height: "100%",
                            overflowY: "auto",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            paddingTop: "1.6rem",
                            paddingBottom: "1.6rem",
                            boxSizing: "border-box",
                        }}
                    >
                        <Notinha />
                    </div>
                )}

                <div
                    style={{
                        width: isMobile || !usarImpressaoNova ? "100%" : "40%",
                        minWidth: isMobile ? "unset" : "650px",
                        height: isMobile ? "auto" : "100%",
                        padding: isMobile ? "1rem" : "1.6rem",
                        overflowY: isMobile ? "visible" : "auto",
                        boxSizing: "border-box",
                    }}
                >
                    {isMobile && usarImpressaoNova && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                marginBottom: "1rem",
                                overflowX: "auto",
                            }}
                        >
                            <Notinha />
                        </div>
                    )}
                    <Configuracoes
                        usarImpressaoNova={usarImpressaoNova}
                        carregandoImpressaoNova={carregandoImpressaoNova}
                        onAlterarImpressaoNova={alterarImpressaoNova}
                    />
                </div>
            </div>
        </div>
    )
}
